/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-dupe-keys */
/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import { DashboardLayout } from "../components/Dashboard"
import { downloadFileWithdrawlApi, requestHttp, updateStatusApi } from '../api/services-third-parties';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Flag from 'react-world-flags';
import {
  ArrowDownTrayIcon,
  ArrowRightIcon,
  EyeIcon,
} from '@heroicons/react/24/outline';
import {
  ValidAccessToken,
  currencyFormatter,
  downloadFile,
  formatDate,
  formatDate_YYYYMMDD,
  formatDate_ddMMYY,
  formatDate_ddMMYYYY,
  formatDecimal,
  format_idByDigit,
  pagesRouter,
  stringMin,
} from '../core/function/function-generic';
import { BatchStatus, TypeOperations } from '../core/enum';
import { Tooltip } from '../components/Tooltip';
import { StatusType } from '../components/StatusType';
import { TableGen2 } from '../components/table-gen-2';
import { Currency } from '../components/Currency';
import { FromTransaction, ToTransaction } from '../components/FromTransaction';
import SearchFilterComponent from '../components/searchFilter';
import ModalComponent from '../components/modal/modal';
import { RegExpValidator } from '../core/regExp-generic';
import LoadingComponent from '../components/loading/loading';
import { ToastContainer, toast } from 'react-toastify';
import { toastError } from '../core/toast/toastAlert';
import { TransactionController } from '../core/controller/transactionCtrl';
import { HomeController } from '../core/controller/HomeCtrl';

export const Withdrawal = () => {
  let countRender = 0
  document.body.style.background = "#FFF";
  const transactionController = new TransactionController()
  const homeController = new HomeController()
  const state = useSelector((state) => state.business);
  const location = useLocation();
  const [dataWithdrawal, setWithdrawal] = useState([]);
  const [datatypeOpreation, setdatatypeOpreation] = useState('');
  const [filter, setFilter] = useState('24 hour');
  const [timeoutId, setTimeoutId] = useState(0);
  const [pagesPagination, setpagesPagination] = useState(1);
  const [digitId, setdigitId] = useState(-4);
  const [open, setOpen] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [dataOperation, setdataOperation] = useState(false);
  const [isApprove, setIsApprove] = useState(false);
  const [valuePeriod, setValuePeriod] = useState(null)
  const [valueSearch, setValueSearch] = useState(null)
  const [valueStatus, setValueStatus] = useState(null)

  const [dataTable, setDataTable] = useState({
    divContent: 'table-info w-[82%] sm:w-[82%] md:w-full lg:w-full xl:w-full h-[60vh]',
    classTable: 'w-full min-w-max table-auto',
    columns: [
      {
        nameColumn: "Name",
        keysColumns: 'name',
        classThHead: 'pl-6 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
        classStyles: 'py-6 pl-6 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
      },
      {
        nameColumn: "Date",
        keysColumns: 'dateNew',
        classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
        classStyles: 'py-6 pl-4 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
      },
      {
        nameColumn: "Amount",
        keysColumns: 'cash_amount',
        classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
        classStyles: 'py-6 pl-4 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
      },
      {
        nameColumn: "Country",
        keysColumns: 'country',
        classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
        classStyles: 'py-6 pl-4 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
      },
      {
        nameColumn: "Method",
        keysColumns: 'method',
        classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
        classStyles: 'py-6 pl-4 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
      },
      {
        nameColumn: "Status",
        keysColumns: 'status',
        classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
        classStyles: 'pt-[2.5rem] w-full flex justify-start  text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
      },
      {
        nameColumn: "ID",
        keysColumns: 'id2',
        classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
        classStyles: 'py-6 pl-4 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5 '
      },
    ],
    data: [],
    classTrBody: 'bord-th-body-table',
    totalPages: 0,
    isAction: true,
    actionIcon: [],
    iconClass: `border-fff`
  });

  const [datatap, setdatatap] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    setFilter('24 hour')
    setdatatap([
      { name: 'Transactions', value: 'transactions', class: 'home-title-tap fontPageTitle text-center cursor-pointer', actionTypeBusiness: ['IN'] },
      { name: 'Withdrawal', value: 'withdrawal', class: 'home-title-tap fontPageTitle text-center cursor-pointer', actionTypeBusiness: ['OUT'] },
      { name: 'Deposit', value: 'deposit', class: 'home-title-tap fontPageTitle text-center cursor-pointer', actionTypeBusiness: ['OUT'] },
      { name: 'Invoices', value: 'invoice', class: 'home-title-tap fontPageTitle text-center cursor-pointer', actionTypeBusiness: ['IN'] },
    ])
    ValidAccessToken()
    if (state.typeBusiness === 'OUT') {
      getWithdrawal(state.id, '24 hour', null, pagesPagination, 'withdrawal');
    } else {
      getInvoiceTransaction(state.id, '24 hour', null, pagesPagination, 'transactions');
    }
  }, []);

  const getWithdrawal = async (id, filterDate, status = null, pages, typeOperation, search = null) => {
    try {
      setisLoading(true)
      setFilter(filterDate)
      setValuePeriod(filterDate)
      sessionStorage.setItem('time', filterDate)
      setdatatypeOpreation(typeOperation);
      setpagesPagination(pages);

      const response = await requestHttp(
        `/withdrawals/businessList/${state.id}?order=DESC&page=${pages}&type=${typeOperation}&take=10&filters=${filterDate}${status === null ? '' : `&status=${status}`}${(search) ? `&search=${search}` : ``}`,
        'GET',
      )
      responseRequest(response);
    } catch (err) {
      setisLoading(false)
      console.error(err);
    }
  }

  const getInvoiceTransaction = async (id, filterDate, status = null, pages, typeOperation, search = null) => {
    setisLoading(true)
    setdatatypeOpreation(typeOperation);
    setpagesPagination(pages);
    setValuePeriod(filterDate)
    setFilter(filterDate)
    sessionStorage.setItem('time', filterDate)

    const response = await requestHttp(
      `/transacction/invoices/${id}?order=DESC&page=${pages}&take=10&filters=${filterDate}${status === null ? '' : `&status=${status}`}`,
      'GET',
    )

    if (response.statusCode >= 400) {
      setisLoading(false)
      toast.error(response.message, toastError)
      return
    }

    if (response.data.statusCode >= 400) {
      setisLoading(false)
      toast.error(response.data.message, toastError)
      return
    }

    responseRequestIn(response, typeOperation);


  }

  const getRetriveCMS = async (idTXTrsnaction) => {
    try {
      setisLoading(true)
      const response = await homeController.getTransactionRetriveCmsById(idTXTrsnaction)

      if (response.statusCode >= 400) {
        setisLoading(false)
        toast.error(response.message, toastError)
        return
      }

      if (response.data.statusCode >= 400) {
        setisLoading(false)
        toast.error(response.data.message, toastError)
        return
      }
      setIsApprove(true)
      setisLoading(false)
      return dataMapRetriveCMS(response['data']['data'])

    } catch (error) {
      setIsApprove(false)
      setisLoading(false)
      if (error.response.data.message.includes('null')) {
        toast.info('The transaction has not been approved', toastError)
      } else {
        toast.error(error.response.data.message, toastError)
      }
    }

  }

  const dataMapRetriveCMS = (row) => {
    console.log(row)
    const dataFrom = row.detailFrom.split('-')
    const dataTo = row.detailTo.split('-')
    return {
      name: row.legalname,
      email: row.email,
      phoneNumber: row.phone,
      typeOperation: TypeOperations[row.type],
      from: state.typeBusiness === 'OUT' ? (
        <ToTransaction
          nameBank={row.detailTo.includes('NO CUSTODIAL') ? dataTo[0] + ' ' + dataTo[2] : dataTo[0]}
          address={dataTo[1]}
        />
      ) : (
        <FromTransaction
          nameMoney={dataFrom[0]}
          address={dataFrom[1]}
          red={dataFrom[2]}
        />
      ),
      to: state.typeBusiness === 'OUT' ? (
        <FromTransaction
          nameMoney={dataFrom[0]}
          address={dataFrom[1]}
          red={dataFrom[2]}
        />
      ) : (
        <ToTransaction
          nameBank={dataTo[0]}
          address={dataTo[1]}
        />
      ),
      idTransaction: row.idTransaction,
      kyc: row.kyc,
      userId: row.idUser
    }
  }

  const dataMap = (row) => {
    return row.map((item) => {
      const dataFrom = item.from.split('-')
      const dataTo = item.to.split('-')
      return {
        userId: item.userId,
        name: item.name,
        dateNew: (
          <Tooltip
            name={formatDate_ddMMYY(item.date)}
            nameTooltip={formatDate(item.date)}
          />
        ),
        date: formatDate_ddMMYYYY(item.date),
        amount: formatDecimal(parseInt(item.amount)),
        country: (
          <>
            <Flag className="h-[1.0rem] inline-block" code={item.country} />
            <span className='ml-[10px]'></span>
          </>
        ),
        typeOperation: item.typeOperation,
        method: stringMin(item.method),
        token: item.token,
        status: (<StatusType name={item.status} idTransaction={item.id} handleChangeStatus={handleChangeStatus} />),
        statusName: item.status,
        id: item.id,
        id2: item.id,
        from: state.typeBusiness === 'OUT' ? (
          <ToTransaction
            nameBank={item.to.includes('NO CUSTODIAL') ? dataTo[0] + ' ' + dataTo[2] : dataTo[0]}
            address={dataTo[1]}
          />
        ) : (
          <FromTransaction
            nameMoney={dataFrom[0]}
            address={dataFrom[1]}
            red={dataFrom[2]}
          />
        ),
        to: state.typeBusiness === 'OUT' ? (
          <FromTransaction
            nameMoney={dataFrom[0]}
            address={dataFrom[1]}
            red={dataFrom[2]}
          />
        ) : (
          <ToTransaction
            nameBank={dataTo[0]}
            address={dataTo[1]}
          />
        ),
        phoneNumber: item.phoneNumber,
        email: item.email,
        enddateNew: formatDate_ddMMYYYY(item.date),
        dateNew: (
          <Tooltip
            name={formatDate_ddMMYY(item.date)}
            nameTooltip={formatDate(item.date)}
          />
        ),
        cash_amount: (
          <Currency
            amount={item.amount}
            currencyFrom={item.currencyOrigin}
            currencyTo={item.currency}
          />
        ),
        amount: currencyFormatter({
          currency: "USD",
          value: item.amount
        }),
        rate: formatDecimal(item.rate),
        idTransaction: item.idTransaction
      }
    })
  }

  const dataMapIn = (row, typeOperationIn) => {
    return row.map((item) => {
      return (typeOperationIn === 'invoice')
        ? {
          name: item.method.user,
          transaction: item.method.transaction,
          typeOperationTransaction: typeOperationIn,
          startdate: (
            <Tooltip
              name={formatDate_ddMMYY(item.start_time)}
              nameTooltip={formatDate(item.start_time)}
            />
          ),
          enddate: (
            <Tooltip
              name={formatDate_ddMMYY(item.end_time)}
              nameTooltip={formatDate(item.end_time)}
            />
          ),
          enddateNew: formatDate_ddMMYYYY(item.method.date),
          method: stringMin(item.method.cashout),
          chain: stringMin(item.chain),
          currency: item.currency,
          cash_amount: (
            <Currency
              amount={item.method.cash_amount}
              currencyFrom={item.method.currency_pay}
              currencyTo={item.currency}
            />
          ),
          amount: currencyFormatter({
            currency: "USD",
            value: item.method.cash_amount
          }),
          status: (<StatusType name={item.estatus_invoice} idTransaction={item.id} handleChangeStatus={handleChangeStatus} />),
          statusName: item.estatus_invoice,
          kyb: item.method.KYB,
          country: (
            <>
              <Flag className="h-[1.0rem] inline-block" code={item.method.country_withdraw} />
              <span className='ml-[10px]'></span>
            </>
          ),
          countryName: item.method.country_withdraw,
          cashout: item.method.cashout,
          time_payout: item.method.time_payout,
          time_estimate_payout: item.method.time_estimate_payout,
          id: item.id,
          id2: format_idByDigit(item.id, digitId),
          date: formatDate(item.method.date),
          dateNew: (
            <Tooltip
              name={formatDate_ddMMYY(item.method.date)}
              nameTooltip={formatDate(item.method.date)}
            />
          ),

        } : {
          transaction: item.method.transaction,
          name: item.method.user,
          typeOperationTransaction: typeOperationIn,
          date: formatDate(item.method.date),
          enddateNew: formatDate_ddMMYYYY(item.method.date),
          dateNew: (
            <Tooltip
              name={formatDate_ddMMYY(item.method.date)}
              nameTooltip={formatDate(item.method.date)}
            />
          ),
          cash_amount: (
            <Currency
              amount={item.method.cash_amount}
              currencyFrom={item.method.currency_pay}
              currencyTo={item.currency}
            />
          ),
          amount: currencyFormatter({
            currency: "USD",
            value: item.method.cash_amount
          }),
          country: (
            <>
              <Flag className="h-[1.0rem] inline-block" code={item.method.country_withdraw} />
              <span className='ml-[10px]'></span>
            </>
          ),
          countryName: item.method.country_withdraw,
          type: TypeOperations[item.type],
          cashout: item.method.cashout,
          status: (<StatusType name={item.method.status} idTransaction={item.method.transaction} handleChangeStatus={handleChangeStatus} />),
          statusName: item.method.status,
          id: item.method.transaction,
          id2: format_idByDigit(item.method.transaction, digitId),
          method: stringMin(item.method.cashout),
        }
    })

  }

  const handleEdit = (id, action) => {
    navigate((action === 'edit') ? `/edit/${id}` : `/download`);
  }

  const onSearch = async (valueFilter) => {
    if (state.typeBusiness === 'OUT') {
      await getWithdrawal(state.id, valueFilter, null, pagesPagination, datatypeOpreation);
    } else {
      await getInvoiceTransaction(state.id, valueFilter, null, 1, datatypeOpreation);
    }
  }

  const responseRequest = (response) => {
    if (response.statusCode >= 400) {
      setWithdrawal([]);
      setisLoading(false)
      toast.error(response.message, toastError)
      const dataMok = []
      setWithdrawal(dataMok);
      setDataTable((prevDataTable) => ({
        ...prevDataTable,
        data: (datatypeOpreation === 'transactions') ? dataMap(dataMok) : dataMok,
        totalPages: 0,
        actionIcon: activeTypeBusinnes(state.typeBusiness)
      }));
    }

    if (response.data.statusCode >= 400) {
      setWithdrawal([]);
      setisLoading(false)
      toast.error(response.data.message, toastError)
      const dataMok = []
      setWithdrawal(dataMok);
      setDataTable((prevDataTable) => ({
        ...prevDataTable,
        data: (datatypeOpreation === 'transactions') ? dataMap(dataMok) : dataMok,
        totalPages: 0,
        actionIcon: activeTypeBusinnes(state.typeBusiness)
      }));
    }

    if ([202].includes(response.data.statusCode)) {
      setisLoading(false)
      setWithdrawal([]);
      if (!response.data.data) {
        setDataTable((prevDataTable) => ({
          ...prevDataTable,
          data: [],
          totalPages: 0,
          actionIcon: activeTypeBusinnes(state.typeBusiness)
        }));

        return
      }
      const res = response.data['data']['data'];
      const totalPages = response['data']['data']['meta']['pageCount'];

      setWithdrawal(res);
      setDataTable((prevDataTable) => ({
        ...prevDataTable,

        data: dataMap(res),
        actionIcon: activeTypeBusinnes(state.typeBusiness),
        totalPages: totalPages
      }));
    }
  }

  const responseRequestIn = (response, typeOperationIn) => {
    let columnTable = (typeOperationIn !== 'invoice') ? [
      {
        nameColumn: "Name",
        keysColumns: 'name',
        classThHead: 'pl-6 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb] rounded-l-[20px]',
        classStyles: 'py-6 pl-6 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
      },
      {
        nameColumn: "Date",
        keysColumns: 'dateNew',
        classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
        classStyles: 'py-6 pl-4 text-justify'
      },
      {
        nameColumn: "Amount",
        keysColumns: 'cash_amount',
        classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
        classStyles: 'py-6 pl-4 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
      },
      {
        nameColumn: "Country",
        keysColumns: 'country',
        classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
        classStyles: 'py-6 pl-4 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
      },
      {
        nameColumn: "Method",
        keysColumns: 'method',
        classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
        classStyles: 'py-6 pl-4 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
      },
      {
        nameColumn: "Status",
        keysColumns: 'status',
        classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
        classStyles: 'pt-[2.5rem] w-full flex justify-start text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
      },
      {
        nameColumn: "ID",
        keysColumns: 'id2',
        classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb] rounded-r-[20px]',
        classStyles: 'py-6 pl-4 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5 '
      },
    ] : [
      {
        nameColumn: "Name",
        keysColumns: 'name',
        classThHead: 'pl-6 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb] rounded-l-[20px]',
        classStyles: 'py-6 pl-6 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
      },
      {
        nameColumn: "Amount",
        keysColumns: 'cash_amount',
        classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
        classStyles: 'py-6 pl-4 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
      },
      {
        nameColumn: "Start Time",
        keysColumns: 'startdate',
        classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
        classStyles: 'py-6 pl-4 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
      },
      {
        nameColumn: "End Time",
        keysColumns: 'enddate',
        classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
        classStyles: 'py-6 pl-4 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
      },
      {
        nameColumn: "Method",
        keysColumns: 'method',
        classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
        classStyles: 'py-6 pl-4 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
      },
      {
        nameColumn: "Chain",
        keysColumns: 'chain',
        classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
        classStyles: 'py-6 pl-4 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
      },
      {
        nameColumn: "Status",
        keysColumns: 'status',
        classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb]',
        classStyles: 'py-6 w-full pl-4 text-justify flex justify-start  text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
      },
      {
        nameColumn: "ID",
        keysColumns: 'id2',
        classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold bg-[#f9fafb] rounded-r-[20px]',
        classStyles: 'py-6 pl-4 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5 '
      },
    ]

    if (response.statusCode >= 400) {
      toast.error(response.message, toastError)
      setisLoading(false)
      setWithdrawal([]);
      setDataTable((prevDataTable) => ({
        ...prevDataTable,
        columns: columnTable,
        data: [],
        totalPages: 0,
        actionIcon: activeTypeBusinnes(state.typeBusiness)
      }));
    }

    if (response.data.statusCode >= 400) {
      setisLoading(false)
      toast.error(response.data.message, toastError)
      setWithdrawal([]);
      setDataTable((prevDataTable) => ({
        ...prevDataTable,
        columns: columnTable,
        data: [],
        totalPages: 0,
        actionIcon: activeTypeBusinnes(state.typeBusiness)
      }));
    }

    if ([202].includes(response.data?.statusCode)) {
      setisLoading(false)
      setWithdrawal([]);
      const res = response.data['data']['data'];
      const totalPages = response['data']['data']['meta']['pageCount'];

      setWithdrawal(res);
      setDataTable((prevDataTable) => ({
        ...prevDataTable,
        columns: columnTable,
        data: dataMapIn(res, typeOperationIn),
        actionIcon: activeTypeBusinnes(state.typeBusiness),
        totalPages: totalPages
      }));
    }
  }

  const handleChangeStatus = async (event, idTransaction) => {
    console.log(event)
    if (['COMPLETED', 'REJECTED'].includes(event)) {

      const params = {
        id: idTransaction,
        status: event === 'COMPLETED' ? true : false,
        refPayment: `A status change from PENDING to ${event} was made for transaction ${idTransaction}`,
        business: state.id
      }

      const { status } = await updateStatusApi(params);
      if (status === 200) {
        const timeTrans = sessionStorage.getItem('time')
        getWithdrawal(state.id, timeTrans, null, pagesPagination, datatypeOpreation, null);
      }
      return;
    }
  }

  const onsearchFilter = (e) => {
    setdatatypeOpreation(e.toLowerCase());
    if (state.typeBusiness === 'OUT') {
      getWithdrawal(state.id, filter, null, 1, e.toLowerCase());
    } else {
      if (e.toLowerCase() === 'invoice') {
        getInvoiceTransaction(state.id, filter, null, 1, e.toLowerCase());
      } else {
        getInvoiceTransaction(state.id, filter, null, 1, e.toLowerCase());
      }

    }

  }

  const SectionTap = (props) => {
    const { onsearchFilter } = props;

    return (
      <section className='flex'>
        {datatap.map((itemTap) => {
          if (itemTap.actionTypeBusiness.includes(state.typeBusiness)) {
            const isTapActive = itemTap.name.toLowerCase().includes(datatypeOpreation);
            const tapClassName = isTapActive ? `${itemTap.class} tap-actve` : itemTap.class;
            return (
              <div
                key={itemTap.name}
                className={tapClassName}
                onClick={() => onsearchFilter(itemTap.value.toLowerCase())}
              >
                {itemTap.name}
              </div>
            );
          } else {
            return null;
          }
        })}
      </section>
    );
  }
  const handleDownload = async () => {
    try {

      const today = new Date();
      if (state.typeBusiness === 'OUT') {
        const newDate = new Date(today.getTime() - (30 * 24 * 60 * 60 * 1000));
        const params = {
          business: state.id,
          fileType: 'csv',
          status: BatchStatus.all,
          fromDate: formatDate_YYYYMMDD(newDate),
          toDate: formatDate_YYYYMMDD(today),
          typeOperation: datatypeOpreation
        }

        const response = await downloadFileWithdrawlApi(params);
        if (response.status === 200) {
          downloadFile(response.data, today, datatypeOpreation)
        }
      } else {
        const response = await transactionController.getTransactionsDownloadByBusinessId(state.id)
        downloadFile(response.data, today, datatypeOpreation)
      }

    }
    catch (error) {

    }
  }

  const onFilter = async (nameFilter, valueFilter) => {
    if (nameFilter === 'period') {
      setValuePeriod(valueFilter)
      if (state.typeBusiness === 'OUT') {
        await getWithdrawal(state.id, valueFilter, valueStatus, pagesPagination, datatypeOpreation, valueSearch);
      } else {
        await getInvoiceTransaction(state.id, valueFilter, valueStatus, pagesPagination, datatypeOpreation, valueSearch);
      }
      return
    }

    if (nameFilter === 'status') {
      setValueStatus(valueFilter)
      if (state.typeBusiness === 'OUT') {
        await getWithdrawal(state.id, valuePeriod, valueFilter, pagesPagination, datatypeOpreation, valueSearch);
      } else {
        await getInvoiceTransaction(state.id, valuePeriod, valueFilter, pagesPagination, datatypeOpreation, valueSearch);
      }
      return
    }

    if (nameFilter === 'search') {
      const searchTerm = RegExpValidator.numeric.test(valueFilter) ? parseInt(valueFilter) : valueFilter
      clearTimeout(timeoutId);
      setTimeoutId(setTimeout(async () => {
        if (state.typeBusiness === 'OUT') {
          await getWithdrawal(state.id, valuePeriod, valueStatus, pagesPagination, datatypeOpreation, searchTerm);
        } else {
          await getInvoiceTransaction(state.id, valuePeriod, valueStatus, pagesPagination, datatypeOpreation, searchTerm);
        }
      }, 2000));

      setTimeout(() => {
        clearTimeout(timeoutId);
      }, 2000);
      setValueSearch(searchTerm)
      return
    }
  }

  const activeTypeBusinnes = (typeBusiness) => {
    if (typeBusiness === 'OUT') {
      return [
        { icon: <ArrowDownTrayIcon className='w-[1.5rem] color-Logout cursor-pointer' />, action: 'download' },
        { icon: <EyeIcon className='w-[1.5rem] color-Logout cursor-pointer' />, action: 'view' },
      ]
    } else {
      return [
        { icon: <EyeIcon className='w-[1.5rem] color-Logout cursor-pointer' />, action: 'view' },
      ]
    }
  }

  const handleNextPageClick = (e) => {
    setpagesPagination((e.selected + 1))
    if (state.typeBusiness === 'OUT') {
      getWithdrawal(state.id, valuePeriod, valueStatus, (e.selected + 1), datatypeOpreation, valueSearch);
    } else {
      getInvoiceTransaction(state.id, valuePeriod, valueStatus, (e.selected + 1), datatypeOpreation, valueSearch);
    }
  }

  const onAction = (e) => {
    if (['edit'].includes(e.action)) {
      if (['pending'].includes(e.data.statusName.toLowerCase())) {
        handleEdit(e.id, e.action);
      }
    }

    if (['download'].includes(e.action)) {
      handleEdit(e.id, e.action);
    }

    if (e.action === 'view') handleOpen(e.data);
  }


  const handleOpen = async (row) => {
    if (state.typeBusiness === 'OUT') {
      //const data = await getRetriveCMS(row.idTransaction)
      setdataOperation({ ...row });
    } else {
      /*
      if (row.statusName === 'pending') {
        setdataOperation({ ...row });
        setOpen(true);
        return
      }
      */

      const data = await getRetriveCMS(row.transaction)
      console.log(data)
      setdataOperation({ ...row, ...data });
    }

    setOpen(true);
  }

  const closeModal = (e) => {
    setOpen(e);
  }

  const onSearchGen = (e) => {
    if (state.typeBusiness === 'OUT') {
      clearTimeout(timeoutId);
      setTimeoutId(setTimeout(() => {
        const searchTerm = e.target.value;
        getWithdrawal(state.id, filter, pagesPagination, datatypeOpreation, searchTerm);
      }, 2000));

      setTimeout(() => {
        clearTimeout(timeoutId);
      }, 2000);
    }
  }

  const onNavigateDetails = (userId) => {
    if (isApprove) {
      navigate(`/withdrawal/details/${userId}`)
    }
  }

  return (
    <>
      <LoadingComponent isOpen={isLoading} />
      <DashboardLayout pageTitle={pagesRouter(location.pathname)} onSearchGen={onSearchGen} onExportFile={handleDownload}>
        <ModalComponent isOpen={open} closeModal={closeModal} withWindows='800px'>
          <div className="flex items-start justify-between p-5 border-b 
            border-solid border-slate-200 rounded-t">
            <p className={`text-20-700`}>
              {datatypeOpreation === 'invoice' ? 'Invoice' : 'Transactions'} Information
            </p>
            <button
              className="p-1 ml-auto bg-transparent border-0 text-black 
                    float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
              onClick={() => closeModal(false)}
            >
              <span className="text-black h-6 w-6 text-2xl block outline-none">
                ×
              </span>
            </button>
          </div>
          <div>
            <div className="grid grid-cols-2 w-full p-transaction">
              <div className="col-span-1">
                <p className="text-16">{datatypeOpreation === 'invoice' ? 'Invoice' : 'Transactions'} Details</p>
              </div>
              <div className="flex justify-end">
                <div className="text-end">
                  <div className="flex items-center flex-wrap mb-2 text-14 w-full  mr-4">
                    <div><span className="mr-[16px]">Status</span></div>
                    <div className={`w-[7.5rem] cursor-default badge bg-color-${dataOperation?.statusName?.toLowerCase()}`}>
                      <span className={`fontPageTitle600`}>{stringMin(dataOperation?.statusName)}</span>
                    </div>
                  </div>
                </div>
                <div className="mr-[16px]">
                  <label className="flex items-center mb-2 text-14 w-full  mr-[16px]">
                    <div><span className="mr-[16px]">KYC</span></div>
                    <div className="w-full fontPageTitle600 badge bg-color-approved text-max-center">
                      <span className={`fontPageTitle600`}>
                        {dataOperation?.kyc ? 'Verified' : 'Not Verified'}
                      </span>
                    </div>
                  </label>
                </div>
                <div></div>
              </div>
            </div>
            <div className="grid gap-6 m-[20px] md:grid-cols-3 ">
              <div>
                <label className="block mb-2 text-14-500">Method</label>
                <div className="text-14-111312-700">
                  {(dataOperation?.method) ? dataOperation?.method : ''}
                </div>
              </div>
              <div>
                <label className="block mb-2 text-14-500">Amount</label>
                <div className="text-14-111312-700">
                  {(dataOperation?.amount) ? dataOperation?.amount : ''}
                </div>
              </div>
              <div></div>
              <div className="">
                <label className="block mb-2 text-14-500">Country</label>
                <div className="text-14-111312-700">
                  {dataOperation?.country} <span className="fontPageTitle600">{dataOperation?.countryName}</span>
                </div>
              </div>
              <div className="">
                <label className="block mb-2 text-14-500">From</label>
                <div className="text-14-111312-700">
                  <span className="fontPageTitle600">{(dataOperation?.from) ? dataOperation?.from : 'N/A'}</span>
                </div>
              </div>
              <div>
                <label className="block mb-2 text-14-500">To</label>
                <div className="text-14-111312-700">
                  <span className="fontPageTitle600">{(dataOperation?.to) ? dataOperation?.to : 'N/A'}</span>
                </div>
              </div>
            </div>
            <div className="grid gap-6 m-[20px]">
              <p className="text-17-700">User Details</p>
            </div>
            <div className="grid gap-6 grid-cols-3 m-[20px]">
              <div>
                <label className="block mb-2 text-14-500">Name</label>
                <div className="text-14-111312-700">
                  {(dataOperation?.name) ? dataOperation?.name : ''}
                </div>
              </div>
              <div>
                <label className="block mb-2 text-14-500">Phone number</label>
                <div className="text-14-111312-700">
                  {(dataOperation?.phoneNumber) ? dataOperation?.phoneNumber : 'N/A'}
                </div>
              </div>
              <div></div>
              <div className="">
                <label className="block mb-2 text-14-500">Email</label>
                <div className="text-14-111312-700">
                  {(dataOperation?.email) ? dataOperation?.email : 'N/A'}
                </div>
              </div>
            </div>
            <div className={`w-auto flex ${!['pending'].includes(dataOperation?.statusName?.toLowerCase()) ? 'justify-around' : ''} gap-6 m-[10px] mb-[40px]`}>
              <div className="sm:w-full md:w-[10%]">
                <label className="block mb-[11px] ml-[10px] text-12"> Date </label>
                <p className="ml-[10px] text-14-400-000">{dataOperation?.enddateNew}</p>
              </div>
              <div className="sm:w-full md:w-[50%]">
                <label className="block mb-2 ml-[10px] text-12">Transaction ID</label>
                <div className="ml-[10px] text-16">{dataOperation.id}</div>
              </div>
              {
                isApprove && (
                  <div className="self-center">
                    <button
                      className="p-3 rounded-lg border"
                      type="button"
                      onClick={() => onNavigateDetails(dataOperation.userId)}
                    >
                      <div className="flex items-center">
                        <div className="font-semibold font-[Inter] leading-5 not-italic text-[14px] text-[#344054]">
                          View {datatypeOpreation === 'invoice' ? 'invoice' : 'transactions'} Details
                        </div>
                        <div><ArrowRightIcon className='ml-2 w-[1.5rem] cursor-pointer' /></div>
                      </div>
                    </button>
                  </div>
                )
              }
            </div>
          </div>
        </ModalComponent>
        <section className='flex flex-wrap w-full justify-between'>
          <div className='grow'>
            <SectionTap onsearchFilter={onsearchFilter} />
          </div>
          <div className='grow'>
            <SearchFilterComponent onFilter={onFilter} dataOption={(state.typeBusiness === 'OUT' ? 'out' : 'in')} />
          </div>
        </section>
        <TableGen2
          dataTableGen={dataTable}
          handleNextPageClick={handleNextPageClick}
          onAction={onAction} />
        <ToastContainer />
      </DashboardLayout>
    </>
  )
}